<button
  (click)="openTalktoSales()"
  class="btn"
  [class.btn-outline]="!isPrimary"
  [class.btn-full]="isPrimary"
>
  {{ _text }}
</button>

<sw-modal
  *ngIf="isModalOpen"
  [position]="'right'"
  [title]="'Contact our dedicated team'"
  (closed)="closeModal()"
>
  <app-talktosales [hubspotId]="hubspotId"></app-talktosales>
</sw-modal>
